module.exports = __webpack_public_path__ + "img/IMG_7246.125fd5bb.jpg";